import { create } from 'zustand';

/**
 * approval store — bump 패턴 (notificationStore 와 동일).
 *
 * 사용:
 *   - TopBar 의 useSSE({ mode: 'me', onApprovalStatus }) 가 store.bumpApprovalStatus() 호출
 *   - ApprovalPage 가 useEffect deps [lastApprovalStatusBump] 로 list refetch
 *   - sse/me 단일 연결 layout level — per-user 동시 한도 절약
 *
 * bump 패턴 일반화 (knowledge candidate):
 *   - notificationStore.lastNotificationBump
 *   - approvalStore.lastApprovalStatusBump
 *   - 향후 calendar invite / mention 등 동일 패턴 확장
 */

interface ApprovalState {
  lastApprovalStatusBump: number;
  bumpApprovalStatus: () => void;
  reset: () => void;
}

export const useApprovalStore = create<ApprovalState>((set) => ({
  lastApprovalStatusBump: 0,
  bumpApprovalStatus: () => set((s) => ({ lastApprovalStatusBump: s.lastApprovalStatusBump + 1 })),
  reset: () => set({ lastApprovalStatusBump: 0 }),
}));
